import React from "react";
import { graphql, Link } from "gatsby";
import { getImage, GatsbyImage } from "gatsby-plugin-image";
import Seo from "gatsby-plugin-wpgraphql-seo";

//Custom Imports
//import { blockRendererComponent } from "../config/blockRendererComponent";
import { Banner, Layout } from "../components";

const BlogCategory = ({
  data: {
    wpCategory,
    wpCategory: {
      posts: { nodes },
      pageMeta,
    },
  },
}) => {
  return (
    <>
      <Seo post={wpCategory} />
      <Layout>
        <Banner banner={pageMeta?.pageBanner} />
        <section className="overflow-hidden bg-white py-12">
          <div className="container mx-auto">
            <div className=" flex flex-wrap">
              {nodes.map((item, index) => {
                const image = getImage(
                  item?.featuredImage?.node?.localFile?.childImageSharp
                    .gatsbyImageData
                );
                return (
                  <div
                    className="mb-8 w-full basis-full px-4 lg:w-1/2 lg:basis-1/2"
                    key={index}
                  >
                    {image && <GatsbyImage image={image} alt="" />}
                    <h3 className="mb-4 mt-4 font-openSans text-lg text-secondary">
                      <Link to={item.uri}>{item.title}</Link>
                    </h3>
                    <p
                      className="font-openSans text-xl text-black"
                      dangerouslySetInnerHTML={{
                        __html: item.excerpt,
                      }}
                    ></p>
                    <Link
                      to={item.uri}
                      className="mt-4 inline-block bg-secondary px-8 py-2 font-openSans text-xl text-white transition-all duration-500 hover:bg-primary"
                    >
                      Read More
                    </Link>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      </Layout>
    </>
  );
};

export default BlogCategory;

export const query = graphql`
  query CategoryQuery($id: Int) {
    wpCategory(databaseId: { eq: $id }) {
      uri
      name
      seo {
        title
        metaDesc
        focuskw
        metaKeywords
        metaRobotsNoindex
        metaRobotsNofollow
        opengraphTitle
        opengraphDescription
        opengraphImage {
          altText
          sourceUrl
          srcSet
        }
        twitterTitle
        twitterDescription
        twitterImage {
          altText
          sourceUrl
          srcSet
        }
        canonical
        cornerstone
        schema {
          raw
        }
      }
      posts {
        nodes {
          databaseId
          title
          uri
          excerpt
          isSticky
          featuredImage {
            node {
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH, formats: WEBP)
                }
              }
            }
          }
        }
      }
      pageMeta {
        pageBanner {
          buttonLabel
          buttonLink
          captionContent
          captionTitle
          desktopImage {
            localFile {
              childImageSharp {
                gatsbyImageData(layout: FULL_WIDTH, formats: WEBP)
              }
            }
          }
          position
          showWhiteLogo
          whiteColor
          mobileImage {
            localFile {
              childImageSharp {
                gatsbyImageData(layout: FULL_WIDTH, formats: WEBP)
              }
            }
          }
        }
      }
    }
  }
`;
